import React from 'react';

export default function SingleContactModalContent() {
  return (
    <p>
      Does the school have a dedicated point of contact for support services for
      Veterans, military service members, and their families?
    </p>
  );
}
